import './BusinessLogin.scss';
class BusinessLoginController {
    static $inject = ['AuthenticationService', 'AccountService2', '$timeout', 'BLIP_DOMAIN_URL'];
    constructor(AuthenticationService, AccountService2, $timeout, BLIP_DOMAIN_URL) {
        'ngInject';
        this.AuthenticationService = AuthenticationService;
        this.AccountService2 = AccountService2;
        this.$timeout = $timeout;
        this.BLIP_DOMAIN_URL = BLIP_DOMAIN_URL;
        this.businessName = '';
        this.loading = false;
    }
    async $onInit() {
        this.businessId = this.getParam('id');
        this.businessName = this.getParam('name');
        this.businessName = this.businessName
            ? ', ' + this.businessName + '!'
            : '!';
        this.businessLogo = this.getParam('logo');
        this.businessLogo = this.businessLogo
            ? decodeURIComponent(this.businessLogo)
            : '';
        const businesschatUrl = `${this.BLIP_DOMAIN_URL}businesschat`;
        this.redirectUrl = `${this.BLIP_DOMAIN_URL}logout?redirectUrl=${encodeURIComponent(businesschatUrl)}`;
        if (this.isLogged) {
            this.user = await this.AccountService2.me();
        }
    }
    getParam(value) {
        const url = window.location.href;
        const reg = new RegExp(value + '=([^&]+)');
        const result = reg.exec(url);
        return result ? result[1] : '';
    }
    async login() {
        if (!this.loginForm.$valid) {
            return;
        }
        this.loading = true;
        try {
            await this.AuthenticationService.login(this.email, this.password);
            await this.AccountService2.fetchAndSetAccount();
            this.user = await this.AccountService2.me();
            this.isLogged = true;
        }
        catch (error) {
            console.error(error);
        }
        finally {
            this.$timeout(() => {
                this.loading = false;
            });
        }
    }
}
BusinessLoginController.$inject = ['AuthenticationService', 'AccountService2', '$timeout', 'BLIP_DOMAIN_URL'];
export default BusinessLoginController;
